<app-header [identifier]="identifier" [theme]="theme"></app-header>
<div class="masthead" [ngStyle]="{ 'background-color': theme.primaryColor }">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 [ngStyle]="{ 'color': theme.textColor }">{{jobTitle}}</h2>
      </div>
    </div>
  </div>
</div>
<div class="container mt-5">
  <div class="row">
    <div class="col-md-12">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer [theme]="theme"></app-footer>
</div>
